import styled from 'styled-components';
import { AdornmentLeftMixin } from '../../mixins/components/AdornmentMixin';
import { StyledAdornment } from '../Adornment/Adornment.styles';
var AdornmentLeft = /*#__PURE__*/styled(StyledAdornment).withConfig({
  displayName: "AdornmentLeft",
  componentId: "c11n-8-107-0__sc-i8uzd9-0"
})(["", ""], AdornmentLeftMixin);
AdornmentLeft.displayName = 'AdornmentLeft';

/** @component */
export { AdornmentLeft };